<template>
  <div class="page" style="margin:0">
    <van-skeleton title :row="23" :loading="loading">
      <!-- 顶部搜索 -->
      <div class="classify_top flex-r-s-c">
        <van-search v-model="serValue" class="classify_ser" placeholder="请输入搜索关键词" readonly shape="round"
                    @click="$router.push('/product/searchpro')"
        />
        <div class="classify_kefu flex-r-c-c" style="margin-left:0.15rem" @click="openKeFu">
          <van-icon name="service-o" size="0.5rem" />
          <span>客服</span>
        </div>
      </div>
      <div class="top_classfly_tab">
        <van-tabs v-model="activeKeyTop" @click="onChangeTab">
          <van-tab v-for="(top,index_top) in topList" :key="index_top" :title="top.title" />
        </van-tabs>
      </div>
      <!-- 分类商品 -->
      <div class="classify_pro_list flex-r-s-s">
        <div class="classify_right_tab" :style="{height:bodyHeigt+'px'}">
          <div v-for="(siderFirst,index_siderFirst) in siderFirstList" :key="index_siderFirst"
               :class="firtIndex === index_siderFirst ?'right_tab_first right_tab_first_actived':'right_tab_first' "
          >
            <div :class="firtIndex === index_siderFirst ? 'right_tab_first_name right_tab_first_name_actived':'right_tab_first_name'"
                 @click="firstChange(siderFirst,index_siderFirst)"
            >{{ siderFirst.title }}</div>
            <!-- <template v-if="firtIndex === index_siderFirst">
              <div v-for="(siderSecond,index_siderSecond) in siderFirst.siderSecondList" :key="index_siderSecond"
                   :class="secondIndex === index_siderSecond ? 'right_tab_first_second right_tab_first_second_actived':'right_tab_first_second'"
              >
                <div :class="secondIndex === index_siderSecond ? 'right_tab_first_second_name right_tab_first_second_name_actived':'right_tab_first_second_name'"
                     @click="secondChange(siderSecond,index_siderSecond)"
                >{{ siderSecond.title }}</div>
              </div>
            </template> -->
          </div>
        </div>
        <div class="classify_pro_list_left flex-r-s-c">
          <div class="left_pro_list" :style="{height:bodyHeigt+'px'}">
            <div name="list">
              <MyscrollList ref="myList01" :loading="listLoading" :list="proList" :line-type="1"
                            style=" margin-top: 0rem;" @myload="proload"
              >
                <template #default="slotProps">
                  <proCard03 :id="slotProps.index" :info="slotProps.item" @addCart="openCart" />
                </template>
              </MyscrollList>
            </div>
          </div>
        </div>
      </div>
    </van-skeleton>
    <!-- Tabber -->
    <Tabber ref="tabber" :index="2" />
    <!-- 全部分类的遮盖 -->
    <div v-show="show" class="left_pro_list_all" @click="show = false" />
    <!-- 客服组件 -->
    <kefuBtn ref="mykefuBtn" />
    <!-- 底部弹框 -->
    <van-action-sheet v-model="maskShow">
      <div class="mask_hearder flex-r-sb-c">
        <div class="mask_hearder_title">采购数量</div>
        <div class="mask_hearder_icon">
          <van-icon name="clear" @click="maskShow = false" />
        </div>
      </div>
      <div class="mask_content flex-r-c-s">
        <van-image width="3.41rem" height="2.56rem" :src="openPro.iconUrl" />
        <div class="mask_pro_info flex-c-s-s">
          <div v-if="!showPriceList" class="pro_price">
            <template>
              ￥<span> {{ openPro.price }} </span>
            </template>
          </div>
          <div class="pro_name van-multi-ellipsis--l2" style="margin-top: 0;">{{ openPro.name }}</div>
          <div class="pro_other van-multi-ellipsis--l2">{{ openPro.brand }} | {{ openPro.specifications }}
          </div>
        </div>
      </div>
      <div v-if="showPriceList" class="info_price_list flex-c-c-c" style="margin-left: 0.4rem">
        <div v-for="(prices,prices_index) in showList" :key="prices_index" class="priceList flex-r-sa-c">
          <div class="prices" style="width: 45%;"><span style="font-size: 0.29rem;">￥</span>{{ prices.price }}</div>
          <div v-if="prices.endNum" class="nums" style="width: 45%;">
            {{ prices.startNum }}-{{ prices.endNum }}{{ openPro.unitName }}
          </div>
          <div v-else class="nums" style="width: 45%;">≥{{ prices.startNum }}{{ openPro.unitName }}</div>
        </div>
        <div v-if="pricesAllList.length > 3" class="morePrice flex-r-c-c" @click="showMore">{{ isShow ? '收起':'更多' }}阶梯单价
          <van-icon :name="isShow ? 'arrow-up':'arrow-down'" size="16" color="#999999" style="margin-left: 0.1rem;" />
        </div>
      </div>
      <div class="pro_num flex-r-sb-c">
        <div class="name">采购数量</div>
        <van-stepper v-model="value" :min="min" :max="max" :step="step" integer disable-input theme="round"
                     button-size="22" @change="onChange"
        />
      </div>
      <div class="pro_num flex-r-sb-c">
        <div class="name">总计</div>
        <div class="total_price">￥ <span style="font-size: 0.53rem;">{{ totalProPrice }}</span></div>
      </div>
      <van-divider />
      <div class="mask_pro_btn flex-r-c-c">
        <div class="right_btn flex-r-s-s">
          <div class="right_btn_cart" @click="addCart">加入购物车</div>
          <div class="right_btn_pay" @click="subPro">立即采购</div>
        </div>
      </div>
    </van-action-sheet>

  </div>
</template>

<script>
import './index.scss'
import Tabber from '@/components/tabber'
import MyscrollList from '@/components/MyscrollList'
import proCard03 from '@/components/pro_card_03'
import kefuBtn from '@/components/kefu_btn'
import { shoppingCart_addUnion } from '@/api/cart'
// tagCategoryList  apiWholesaleProduct_productRecommendList
import { apiWholesaleProduct_categoryList, apiWholesaleProduct_productList, wholesale_productPrice } from '@/api/pro'
export default {
  name: 'ProClassify',
  components: { Tabber, MyscrollList, proCard03, kefuBtn },
  data() {
    return {
      bodyHeigt: '',
      value1: '',
      loading: true,
      show: false,
      tagId: '0',
      topList: [],
      serValue: '',
      activeKey: 0,
      activeKeyTop: 0,
      firtIndex: 0,
      secondIndex: 0,
      siderFirstList: [{ siderSecondList: [] }],
      rightTitle: '',
      showPopover: false,
      // 商品列表
      proSearch: { page: 1, limit: 10, categoryId: '', tagId: '' },
      proList: [],
      listLoading: false,
      // 底部弹框
      maskShow: false,
      value: '',
      min: 1,
      max: 9999,
      step: 1,
      totalProPrice: '',
      openPro: {},
      tabberList: [],
      showList: [],
      isShow: false,
      pricesList: [],
      pricesAllList: [],
      showPriceList: false

    }
  },
  created() {
    this.showList = this.pricesList
    console.log('xxx created 进入classify')
    // window.document.title = this.$route.query.name
    this.$utils.cartNum(this.$store)
    // this.proSearch.tagId = this.$route.query.tagId
    // this.tagId = this.$route.query.tagId
    // this.index = parseInt(this.$route.query.index)
    this.getSideData() // 获取侧边分类
    this.$utils.cartNum(this.$store)
    var clientHeight = `${document.documentElement.clientHeight}`
    console.log('clientHeight1', clientHeight) // 1.6  1.4 2 = 7 * 37.5 = 262.5
    this.bodyHeigt = (clientHeight * 1 - 210).toFixed(2)
    console.log('clientHeight2', this.bodyHeigt) // 1.6  1.4 2 = 5 * 37.5 = 187.5
  },
  activated() {
    console.log('xxx keepalive 进入classify')
    // window.document.title = this.$route.query.name
    this.$utils.cartNum(this.$store)
    // this.proSearch.tagId = this.$route.query.tagId
    // this.tagId = this.$route.query.tagId
    // this.index = parseInt(this.$route.query.index)
    console.log('xxx getItem', sessionStorage.getItem('tabberJump'))
    if (sessionStorage.getItem('tabberJump')) {
      console.log('xxx tabberJump')
      this.loading = true
      // this.$router.go(0)
      // window.location.reload()
      sessionStorage.removeItem('tabberJump')
      this.getSideData() // 获取侧边分类
      var clientHeight = `${document.documentElement.clientHeight}`
      this.bodyHeigt = (clientHeight * 1 - 150).toFixed(2)
    } else {
      var id = sessionStorage.getItem('classify_pro_id')
      document.getElementById(id).scrollIntoView()
    }
  },
  deactivated() {
    console.log('keepalive 离开classify')
  },
  methods: {
    toCartPath() { this.$router.push('/cart/cart') },
    getSideData() {
      apiWholesaleProduct_categoryList({page: 1, limit: 999, pId: 0 }).then(res => {
        this.loading = false
        this.topList = res.data.list
        this.onChangeTab(0)
      })
    },
    // 重新加载商品更新事件
    reloadProList() {
      this.proList = []
      this.siderFirstList = []
      this.proSearch.page = 1
    },
    // 顶部切换
    onChangeTab(index) {
      this.reloadProList()
      const nextId = this.topList[index].categoryId
      apiWholesaleProduct_categoryList({page: 1, limit: 999, pId: nextId, type: 'top' }).then(res => {
        this.loading = false
        this.siderFirstList = res.data.list
        this.proSearch.categoryId = res.data.list[0].categoryId
        this.firstChange(res.data.list[0], 0)
        this.$refs.myList01.load_status_clear()
      })
    },
    // 侧边一级切换
    firstChange(item, index) {
      console.log('closePullBox 1')
      this.firtIndex = index
      apiWholesaleProduct_categoryList({page: 1, limit: 999, pId: item.categoryId, type: 'sider' }).then(res => {
        // if (res.data.list.length > 0) {
        //   item.siderSecondList = res.data.list
        //   this.secondChange(res.data.list[0], 0)
        // } else {
        this.$refs.myList01.load_status_clear()
        this.proSearch.categoryId = item.categoryId
        this.rightTitle = item.name
        this.proList = []
        this.proSearch.page = 1
        this.loadPro()
        console.log('this.rightTitle', this.rightTitle)
        // }
      })
    },
    // 侧边二级切换
    secondChange(item, index) {
      console.log('closePullBox 2')
      this.$refs.myList01.load_status_clear()
      this.secondIndex = index
      this.proSearch.categoryId = item.id
      this.rightTitle = item.name
      this.proList = []
      this.proSearch.page = 1
      this.loadPro()
      console.log('this.rightTitle', this.rightTitle)
    },
    // 加载商品
    loadPro(index) {
      apiWholesaleProduct_productList(this.proSearch).then(res => {
        this.$refs.myList01.load_loading(false)
        this.proList = this.proList.concat(res.data.list)
        if (parseInt(res.data.total) === 0) { this.$refs.myList01.load_empty('list', true) } else {
          if (res.data.list.length === 0) { this.$refs.myList01.load_finished(true) } // 数据全部加载完成
        }
      })
    },
    proload() {
      this.$refs.myList01.load_loading(true)
      this.$utils.debounce(() => {
        this.proSearch.page = this.proSearch.page + 1
        this.loadPro()
        // 加载状态结束
      }, 50)()
    },
    openKeFu() { this.$refs.mykefuBtn.changeShow(true) },
    openCart(item) {
      this.openPro = item
      this.maskShow = true
      this.value = item.minQuantity
      if (item.quantity === null || item.quantity === undefined) {
        this.min = item.minQuantity
        this.step = item.multiplyQuantity === 1 ? item.minQuantity : 1
        this.totalProPrice = (parseInt(item.minQuantity) * item.price * 1).toFixed(2)
      } else {
        this.min = item.fashProNum
        this.totalProPrice = (parseInt(item.fashProNum) * item.price * 1).toFixed(2)
      }
      wholesale_productPrice({ productId: item.productId }).then(res => {
        this.showPriceList = res.data.stepPrice.length > 0
        // 获取阶梯价格
        this.pricesAllList = res.data.stepPrice
        if (res.data.stepPrice.length > 3) {
          this.pricesList = [res.data.stepPrice[0], res.data.stepPrice[1], res.data.stepPrice[2]]
          this.showList = [res.data.stepPrice[0], res.data.stepPrice[1], res.data.stepPrice[2]]
        } else {
          this.showList = res.data.stepPrice
        }
      })
    },
    onChange(value) {
      clearTimeout(this.timer)
      var priceNew = this.pricesAllList[0].price
      this.timer = setTimeout(() => {
        this.value = value
        for (var i = 1; i < this.pricesAllList.length; i++) {
          if (value >= this.pricesAllList[i].startNum) {
            priceNew = this.pricesAllList[i].price
            var endNum = this.pricesAllList[i].endNum ? this.pricesAllList[i].endNum : 999999
            if (value >= endNum) { priceNew = this.pricesAllList[i].price; break }
          }
        }
        this.$nextTick(() => { this.totalProPrice = (parseInt(value) * priceNew * 1).toFixed(2) })
      }, 500)
    },
    addCart() {
      const parms = { productId: this.openPro.productId, priceNum: this.value }
      console.log(parms)
      shoppingCart_addUnion(parms).then(res => {
        this.$toast({ message: '加入成功！', duration: 1 * 1000 })
        this.$utils.cartNum(this.$store)
        this.maskShow = false
      })
    },
    subPro() {
      let url = ''
      url = `/order/subOrder?item=${this.openPro.productId}-${this.value}-1000&type=2`
      this.$router.push(url)
    },
    showMore() {
      this.isShow = !this.isShow
      this.showList = []
      this.$nextTick(() => {
        this.showList = this.isShow ? this.pricesAllList : this.pricesList
      })
    }
  }
}
</script>

<style>
</style>
